import React from "react";
import cx from "classnames";
import styles from "../../scss/DigitalAdvice.module.scss";
import useWindowDimensions from "../../../common/hooks/useWindowDimensions";

const DapRecommendationPlaceholder: React.FC = () => {
    const { isTabletPortrait, isTabletLandscape } = useWindowDimensions();

    return (
        <div className={cx([styles["advice-placeholder"]])}>
            <div
                className={cx([
                    styles["our-advice-recommend"],
                    styles["placeholder--item"]
                ])}>
                <div
                    className={cx([
                        styles["placeholder--image"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["placeholder--title"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["placeholder--subtitle"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["placeholder--subtitle"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["placeholder--action"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["placeholder--cover"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["placeholder--cover-item"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["placeholder--cover-item"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["placeholder--cover-item"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["placeholder--cover-item"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["placeholder--cover-item"],
                        styles["pre-loader"]
                    ])}></div>
            </div>
            {!isTabletPortrait && (
                <div
                    className={cx([
                        styles["our-advice-recommend"],
                        styles["placeholder--item"]
                    ])}>
                    <div
                        className={cx([
                            styles["placeholder--image"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--title"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--subtitle"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--subtitle"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--action"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--cover"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--cover-item"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--cover-item"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--cover-item"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--cover-item"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--cover-item"],
                            styles["pre-loader"]
                        ])}></div>
                </div>
            )}
            {!isTabletLandscape && (
                <div
                    className={cx([
                        styles["our-advice-recommend"],
                        styles["placeholder--item"]
                    ])}>
                    <div
                        className={cx([
                            styles["placeholder--image"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--title"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--subtitle"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--subtitle"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--action"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--cover"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--cover-item"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--cover-item"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--cover-item"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--cover-item"],
                            styles["pre-loader"]
                        ])}></div>
                    <div
                        className={cx([
                            styles["placeholder--cover-item"],
                            styles["pre-loader"]
                        ])}></div>
                </div>
            )}
        </div>
    );
};

export default DapRecommendationPlaceholder;
